import React from "react";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import Modal from "@/components/controls/Modal";

interface CreateNewOptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateOption: (optionName: string) => Promise<void>;
  optionName: string;
  title: string;
  description: string;
  createButtonText: string;
  cancelButtonText: string;
}

const CreateNewOptionModal: React.FC<CreateNewOptionModalProps> = ({
  isOpen,
  onClose,
  onCreateOption,
  optionName,
  title,
  description,
  createButtonText,
  cancelButtonText
}) => {
  const handleCreate = async () => {
    await onCreateOption(optionName);
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      setIsOpen={(open) => !open && onClose()}
      title={<Text variant="title3H1">{title}</Text>}
      content={
        <div className="flex flex-col gap-4 p-6">
          <Text variant="body">{description}</Text>
        </div>
      }
      footer={
        <div className="flex items-center justify-end gap-3">
          <Button variant="secondaryNoBg" onClick={onClose}>
            {cancelButtonText}
          </Button>
          <Button onClick={handleCreate}>{createButtonText}</Button>
        </div>
      }
      contentClassname="max-w-md"
      hideDivider={true}
    />
  );
};

export default CreateNewOptionModal;
